import http from '../clients/Axios'

export default class SalesInvoiceService {
  async paginate(pageNumber, pageSize = 10, sortField, sortOrder, filters) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          filters_param =
            filters_param + '&filter[' + el + ']=' + filters[el].value
        }
      })
    }

    const res = await http.get(
      `/sales/invoice/paginate?page[number]=${pageNumber}&page[size]=${pageSize}&sort=${sort}${filters_param}`
    )

    return res.data
  }

  async get(param) {
    param = param ? param : ''
    const res = await http.get(`/sales/invoice${param}`)
    return res
  }

  async add(form) {
    const res = await http.post('/sales/invoice', form)
    return res
  }

  async update(form) {
    const res = await http.post(`/sales/invoice/${form.id}`, form)
    return res
  }

  async delete(id) {
    const res = await http.delete(`/sales/invoice/${id}`)
    return res
  }

  async downloadFaktur(faktur_id) {
    return http({
      url: `/sales/invoice/${faktur_id}/print`,
      method: 'GET',
      responseType: 'blob',
    })
  }

  async downloadSPB(faktur_id) {
    return http({
      url: `/sales/invoice/${faktur_id}/print_spb`,
      method: 'GET',
      responseType: 'blob',
    })
  }
}
